"use strict";

(function () {
	function r(e, n, t) {
		function o(i, f) {
			if (!n[i]) {
				if (!e[i]) {
					var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
				}var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
					var n = e[i][1][r];return o(n || r);
				}, p, p.exports, r, e, n, t);
			}return n[i].exports;
		}for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
			o(t[i]);
		}return o;
	}return r;
})()({ 1: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				wpAdminBar: $('#wpadminbar'),
				siteHeader: $('.site-header')
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				var $dom = this.$dom;

				function moveIfAdminBar() {
					$dom.siteHeader.css('top', $dom.wpAdminBar.height());
					$dom.wpAdminBar.css('position', 'fixed');
				};

				function addGlobalContentOffset() {
					var admBarH = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

					$('.global-margin-top').css('margin-top', $dom.siteHeader[0].getBoundingClientRect().bottom + 'px');
					$('.global-padding-top').css('padding-top', $dom.siteHeader[0].getBoundingClientRect().bottom + 'px');
					$('.global-admin-margin').css('margin-top', admBarH + 'px');
				}

				if ($dom.wpAdminBar.length > 0) {
					moveIfAdminBar();
					addGlobalContentOffset($dom.wpAdminBar.height());
				} else {
					addGlobalContentOffset();
				}

				Global.$dom.window.on('resize', function () {
					clearTimeout(window.resizedFinished);
					window.resizedFinished = setTimeout(function () {
						if ($dom.wpAdminBar.length > 0) {
							moveIfAdminBar();
							addGlobalContentOffset($dom.wpAdminBar.height());
						} else {
							addGlobalContentOffset();
						}
					}, 250);
				});
			}
		};
	}, { "./global": 2 }], 2: [function (require, module, exports) {
		"use strict";

		module.exports = {
			$dom: {
				window: $(window),
				body: $("body")
			},

			vars: {
				windowWidth: window.innerWidth
			},

			functions: {
				escKey: function escKey(callback) {
					$(document).on("keyup", function (e) {
						if (e.keyCode === 27) {
							callback();
						}
					});
				},

				clickOutsideContainer: function clickOutsideContainer(selector, container, closeBtn, callback) {
					selector.on("mouseup", function (e) {
						e.preventDefault();
						if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
							callback();
						}
					});
				}
			}
		};

		/* Questions toggle text */
		$(".scanes__question .font-keyboard-arrow-right").click(function () {
			$(this).toggleClass("font-keyboard-arrow-right--reverse");
			$(this).parent().next(".scanes__question-content").slideToggle("scanes__questions--toggle");
			$(this).parent().find("h2").toggleClass("scanes__questions--toggle-color");
		});

		$(".scanes__question h2").click(function () {
			$(this).next().toggleClass("font-keyboard-arrow-right--reverse");
			$(this).parent().next(".scanes__question-content").slideToggle("scanes__questions--toggle");
			$(this).parent().find("h2").toggleClass("scanes__questions--toggle-color");
		});

		/* Show / hide second menu */
		$("#menu-second-menu").prepend("<a class='menu-btn open menu-btn--second'><span></span><span></span><span></span></a>");

		$(".second-mobile-nav__btn").click(function () {
			$(".menu-second-menu-container").animate({
				left: 0
			});
			$(this).hide();
			$(".sidebar-nav--menu").show();
		});

		$(".menu-btn--second").click(function () {
			$(".menu-second-menu-container").animate({
				left: "-280px"
			});
			$(".second-mobile-nav__btn").show();
		});

		/* Show social share */

		$(".blog__post-social .font-share").click(function (e) {
			e.preventDefault();
			$(this).parent().parent().parent().siblings(".blog__post-social-share").slideToggle();
		});

		$(".all-scans-item__share .font-share").click(function (e) {
			e.preventDefault();
			$(this).parent().parent().children(".all-scan__social-share").slideToggle(500);
		});

		/* Sidebar menus */

		$(".sidebar-nav__list .sub-menu").prev().removeAttr("href");

		if ($(".menu-item-has-children").length > 0) {
			var menuToShow = $(".sidebar-nav__list").find(".current-menu-item");
			$(menuToShow).parent().show();
			$(menuToShow).parent().parent().parent().addClass("sidebar-nav__list--active");
		}

		$(".sidebar-nav__list li a").click(function () {
			$(this).next().slideToggle(700);
		});

		$(".sidebar-nav__list li a").append("<span class='font-keyboard-arrow-right'></span>");

		$(".sidebar-nav__list li a:not([href])").click(function () {
			$(this).children().toggleClass("current-menu-ancestor--active-arrow");
		});

		if ($(".sidebar-nav__list .sub-menu").is(":visible")) {
			$(".sidebar-nav__list .current-menu-ancestor a:not([href]) span").addClass("current-menu-ancestor--active-arrow");
		}

		/* Load more */

		$(function () {
			$(".blog__post").slice(0, 9).show();
			$(".load-more").on("click", function (e) {
				e.preventDefault();
				$(".blog__post:hidden").slice(0, 3).slideDown();
				if ($(".blog__post:hidden").length == 0) {
					$(".load-more").fadeOut("slow");
				}
				$("html,body").animate({
					scrollTop: $(this).offset().top
				}, 1500);
			});
		});

		$(document).ready(function () {
			$("#field-4").remove();
			if ($(".pricing-scans__price-effect").html()) {
				if ($(".pricing-scans__price-effect").html().length > 0) {
					$(".pricing-scans__price-effect:empty").parent().addClass("pricing-scans__price-effect--parent");
				}
			}
		});

		var header = document.querySelector(".js-header");

		var prevPosY = window.scrollY;
		if (window.scrollY > 10) {
			header.classList.add("not-top");
		}

		console.log("fddfd");
		window.addEventListener("scroll", function () {
			console.log("fddfd");
			var posY = window.scrollY;
			if (posY < 10) {
				header.classList.remove("not-top");
			} else {
				header.classList.add("not-top");
			}
			if (posY <= prevPosY || posY <= 0) {
				header.classList.remove("hide");
			} else {
				header.classList.add("hide");
			}
			prevPosY = posY;
		});
	}, {}], 3: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				menuBtn: $('.js-menu-btn'),
				menuNav: $('.js-main-nav'),
				menuHasSub: $('.menu-item-has-children')
			},

			classes: {
				open: 'open',
				openMenu: 'menu-open'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;

				// functions
				function closeNav() {
					$dom.menuBtn.removeClass(classes.open);
					$dom.menuNav.removeClass(classes.open);
					Global.$dom.body.removeClass(classes.openMenu);
				}

				if (Global.vars.windowWidth < 768) {
					$dom.menuHasSub.each(function (i, el) {
						$(el).append('<span class="sub-icon font-plus-circle" data-open-sub></span>');
					});
				}

				// bind events
				$dom.menuBtn.on('click', function (e) {
					e.preventDefault();
					$dom.menuBtn.toggleClass(classes.open);
					$dom.menuNav.toggleClass(classes.open);
					Global.$dom.body.toggleClass(classes.openMenu);
				});

				$dom.menuNav.on('click', '[data-open-sub]', function () {
					if (Global.vars.windowWidth < 768) {
						$(this).siblings('.sub-menu').slideToggle();
					}
				});

				Global.functions.clickOutsideContainer($dom.menuNav, $dom.menuNav.children('ul'), $dom.menuBtn, closeNav);

				Global.functions.escKey(closeNav);
			}
		};
	}, { "./global": 2 }], 4: [function (require, module, exports) {
		"use strict";

		var Global = require('./global'); // require Global only if you need it
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				selectInput: $('.js-select')
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {

				initBasic();

				function initBasic() {
					$('.js-select').select2({}).on('select2:open', function (e) {
						$('.select2-dropdown').hide();
						setTimeout(function () {
							jQuery('.select2-dropdown').slideDown(200);
						}, 0);
					}).on('select2:closing', function (e) {
						e.preventDefault();
						setTimeout(function () {
							jQuery('.select2-dropdown').slideUp(200, function () {
								closeBasic();
							});
						}, 0);
					});
				}

				function closeBasic() {
					$(".js-select").select2('destroy');
					initBasic();
				}
			}
		};
	}, { "./global": 2 }], 5: [function (require, module, exports) {
		"use strict";

		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				slider: $('.js-slider'),
				slider_insta: $('.js-slider-insta'),
				slider_scans: $('.js-slider-scans'),
				slider_blog: $('.js-slider-blog'),
				slider_about: $('.js-slider-about'),
				slider_testamonial_about: $('.js-testamonial-about'),
				slider_our_clinic: $('.js-our-clinic'),
				homeSlidersad: $('.js-home-slidera'),
				homeSlider: $('.js-home-slider')
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				// slider
				$dom.slider.slick({
					prevArrow: $('[data-scan-slider-left]'),
					nextArrow: $('[data-scan-slider-right]'),
					focusOnSelect: true,
					infinite: true,
					slidesToShow: 1,
					fade: true,
					slidesToScroll: 1,
					number: false,
					dots: false,
					arrows: true,
					cssEase: 'ease-in-out',
					autoplay: true,
					autoplaySpeed: 5000,
					responsive: [
						// {
						// 	breakpoint: 991,
						// 	settings: {
						// 		slidesToShow: 3
						// 	}
						// },
						// {
						// 	breakpoint: 767,
						// 	settings: {
						// 		slidesToShow: 2
						// 	}
						// }
					]
				});
				// slider insta
				$dom.slider_insta.slick({
					infinite: true,
					slidesToShow: 7,
					slidesToScroll: 1,
					speed: 1000,
					number: false,
					arrows: false,
					cssEase: 'ease-in-out',
					autoplay: true,
					responsive: [{
						transition: "auto-fade",
						breakpoint: 1400,
						settings: {
							slidesToShow: 5
						}
					}, {
						transition: "auto-fade",
						breakpoint: 1119,
						settings: {
							slidesToShow: 4
						}
					}, {
						transition: "auto-fade",
						breakpoint: 991,
						settings: {
							slidesToShow: 3
						}
					}, {
						transition: "auto-fade",
						breakpoint: 767,
						settings: {
							slidesToShow: 3
						}
					}, {
						transition: "auto-fade",
						breakpoint: 600,
						settings: {
							slidesToShow: 3
						}
					}, {
						transition: "auto-fade",
						breakpoint: 600,
						settings: {
							slidesToShow: 2
						}
					}]
				});
				// slider scans
				$dom.slider_scans.slick({
					prevArrow: $('[data-scan-slider-left]'),
					nextArrow: $('[data-scan-slider-right]'),
					focusOnSelect: true,
					slidesToShow: 1,

					slidesToScroll: 1,
					speed: 1000,
					dots: false,
					cssEase: 'ease-in-out',

					responsive: [
						// {
						// 	transition: "auto-fade",
						// 	breakpoint: 1400,
						// 	settings: {
						// 		slidesToShow: 5
						// 	}
						// },
						// {
						// 	transition: "auto-fade",
						// 	breakpoint: 1119,
						// 	settings: {
						// 		slidesToShow: 4
						// 	}
						// },
						// {
						// 	transition: "auto-fade",
						// 	breakpoint: 991,
						// 	settings: {
						// 		slidesToShow: 3
						// 	}
						// },
						// {
						// 	transition: "auto-fade",
						// 	breakpoint: 767,
						// 	settings: {
						// 		slidesToShow: 2
						// 	}
						// }
					]
				});
				// Blog
				$dom.slider_blog.slick({
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					speed: 1000,
					arrows: false,
					// autoplay: true,
					dots: false,
					fade: false,
					cssEase: 'ease-in-out',
					responsive: [
						// {
						// 	breakpoint: 991,
						// 	settings: {
						// 		slidesToShow: 3
						// 	}
						// },
						// {
						// 	breakpoint: 767,
						// 	settings: {
						// 		slidesToShow: 2
						// 	}
						// }
					]
				});
				// slider about
				$dom.slider_about.slick({
					prevArrow: $('[data-scan-slider-left-img]'),
					nextArrow: $('[data-scan-slider-right-img]'),
					focusOnSelect: true,
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					speed: 1000,
					arrows: true,
					autoplay: true,
					// dots: true,
					// fade: true,
					cssEase: 'ease-in-out',
					responsive: [
						// {
						// 	breakpoint: 991,
						// 	settings: {
						// 		slidesToShow: 3
						// 	}
						// },
						// {
						// 	breakpoint: 767,
						// 	settings: {
						// 		slidesToShow: 2
						// 	}
						// }
					]
				});
				// slider testamonial about us
				$dom.slider_testamonial_about.slick({
					prevArrow: $('[data-scan-slider-left]'),
					nextArrow: $('[data-scan-slider-right]'),
					fade: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					speed: 1000,
					arrows: true,
					cssEase: 'ease-in-out',
					autoplay: true,
					responsive: [
						// {
						// 	breakpoint: 991,
						// 	transition: "auto-fade",
						// 	settings: {
						// 		slidesToShow: 3
						// 	}
						// },
						// {
						// 	breakpoint: 767,
						// 	settings: {
						// 		slidesToShow: 2
						// 	}
						// }
					]
				});
				// slider our clinic
				$dom.slider_our_clinic.slick({
					prevArrow: $('[data-scan-slider-left-clinic]'),
					nextArrow: $('[data-scan-slider-right-clinic]'),
					focusOnSelect: true,

					slidesToShow: 4,
					slidesToScroll: 1,
					speed: 1000,
					arrows: true,
					dots: false,
					cssEase: 'ease-in-out',
					// autoplay: true,
					responsive: [{
						transition: "auto-fade",
						breakpoint: 1400,
						settings: {
							slidesToShow: 5
						}
					}, {
						transition: "auto-fade",
						breakpoint: 1119,
						settings: {
							slidesToShow: 4
						}
					}, {
						transition: "auto-fade",
						breakpoint: 991,
						settings: {
							slidesToShow: 3
						}
					}, {
						transition: "auto-fade",
						breakpoint: 767,
						settings: {
							slidesToShow: 2
						}
					}, {
						transition: "auto-fade",
						breakpoint: 600,
						settings: {
							slidesToShow: 1
						}
					}]
				});

				// home slider
				$dom.homeSlider.slick({
					focusOnSelect: true,
					infinite: true,
					slidesToShow: 1,
					fade: true,
					slidesToScroll: 1,
					speed: 1000,
					dots: true,
					arrows: false,
					cssEase: 'ease-in-out'
				});
			}
		};
	}, {}], 6: [function (require, module, exports) {
		jQuery(function ($) {
			// Site Menu
			var menu = require('./_site/menu');
			menu.init();

			// Slick Slider
			var sliders = require('./_site/sliders');
			sliders.init();

			//Admin Menu
			var adminHeader = require('./_site/adminHeader');
			adminHeader.init();

			var select2 = require('./_site/select2');
			select2.init();
		});

		$(window).load(function () {
			if ($('.flexslider').length > 0) {
				$('.flexslider').flexslider({
					animation: "slide"
				});
			}
		});
	}, { "./_site/adminHeader": 1, "./_site/menu": 3, "./_site/select2": 4, "./_site/sliders": 5 }] }, {}, [6]);